<template>
    <section class="page lenta" style="padding-top: 15px;">
        <Pins 
          :loading="loading"
          :loading_more="loading_more"
          :pins="pins" 
          :adder="true"
        />
        <ModalPhotos />
        <ModalPin 
          :pin="active" 
          v-if="active" 
          @clear="active = null" 
        />
    </section>
</template>

<script>
import Pins from '@/components/Lenta/Pins'

export default {
  name: "lenta",
  components: {
    Pins,
    // Pins: () => import('@/components/Lenta/Pins'),
    ModalPin:  () => import('@/components/Lenta/ModalPin'),
    ModalPhotos:  () => import('@/components/Modals/ModalPhoto')
  },
  
  data: () => ({
    // pins: [],
    active: null,
    panel: false,
    workplace: false,
    title: 'Этот раздел сейчас в разработке',
    content: '<p>Здесь будет лента с постами и возможность вести свой блог.</p>',
    pins_window: null,
    pins_position: null,
    page: 0,
    loading: false,
    loading_more: false
  }),
  computed: {
    userInfo() {
      return this.$store.getters.info;
    },
    getActive () {
      return this.$store.getters.getActiveArticle
    },
    pins () {
      return this.$store.getters.getPins
    },
  },
  methods: {
    async loadData() {
      this.loading = true
      await this.$store.dispatch('getPins', {limit: 6, page: this.page});
      this.loading = false
    },
    async loadMore() {
      this.loading_more = true
      await this.$store.dispatch('getPins', {limit: 6, page: this.page, more: true})
      this.loading_more = false
    },
    lazyLoad() {
      let timeout = false;
      this.pins_window.onscroll = () => {
        if (timeout !== false) {
            clearTimeout(timeout);
        }
        timeout = setTimeout(async () => {
          this.pins_position = this.pins_window.scrollHeight - (this.pins_window.scrollTop + this.pins_window.clientHeight);
            if (this.pins_position < 1000) {
              this.page++
              this.loadMore()
            } 
        }, 300);
      }
    },
    scrollHandler() {
      // TODO: переписать
      this.pins_window = document.querySelector(".pins");
      if (this.pins_window) {
        setTimeout(() => {
          this.lazyLoad()
        }, 1000)
      } else {
        setTimeout(() => {
          this.pins_window = document.querySelector(".pins");
          this.lazyLoad()
        }, 1000)
      }      
    },
    async fetchPin(id) {
      this.active = await this.$store.dispatch('fetchPin', {id});
    }
  },
  mounted() {
      this.loadData()
      this.scrollHandler()
  },
  created () {
    let id = this.$route.params.id;
    id ? this.fetchPin(id) : '';
  }
};
</script>
<style lang="stylus">
  .lenta
    +to-width(540px)
      background-color #f9f9f9
      ::-webkit-scrollbar
        width 4px
        border-radius 50px
        position absolute

      ::-webkit-scrollbar-track
        background var(--background)

      ::-webkit-scrollbar-thumb
        background var(--periphery)
        border-radius 50px

      ::-webkit-scrollbar-thumb:hover
        background #555
        border-radius 50px
  .fullimage
    width 100%
    height 100vh
    display flex
    align-items center
    position relative
    background-color: #020102

  .fullimage img
    width 100%
</style>